import React from 'react';
import { FaPlay, FaClock, FaChalkboardTeacher } from 'react-icons/fa';

const tutorials = [
  {
    title: "SolarTools'a Giriş",
    description: "Platformun temel özelliklerini ve kullanımını öğrenin.",
    duration: "15 dakika",
    instructor: "Ahmet Söylemez",
    videoUrl: "#",
    thumbnail: "/tutorials/intro.jpg"
  },
  {
    title: "Dashboard Oluşturma",
    description: "Özelleştirilmiş dashboard'lar oluşturmayı ve widget'ları yapılandırmayı öğrenin.",
    duration: "20 dakika",
    instructor: "Elif Yıldız",
    videoUrl: "#",
    thumbnail: "/tutorials/dashboard.jpg"
  },
  {
    title: "Veri Analizi",
    description: "Enerji verilerinizi analiz etmeyi ve raporlar oluşturmayı öğrenin.",
    duration: "25 dakika",
    instructor: "Mehmet Kaya",
    videoUrl: "#",
    thumbnail: "/tutorials/analysis.jpg"
  }
];

export default function Tutorials() {
  return (
    <div className="max-w-6xl mx-auto px-4 py-12">
      <h1 className="text-3xl font-bold text-[var(--color-primary)] mb-8">
        Video Eğitimler
      </h1>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
        {tutorials.map((tutorial, index) => (
          <div 
            key={index}
            className="bg-white rounded-xl shadow-lg overflow-hidden"
          >
            <div className="relative">
              <img
                src={tutorial.thumbnail}
                alt={tutorial.title}
                className="w-full h-48 object-cover"
              />
              <div className="absolute inset-0 bg-black bg-opacity-40 flex items-center justify-center opacity-0 hover:opacity-100 transition-opacity">
                <FaPlay className="text-white text-4xl" />
              </div>
            </div>
            
            <div className="p-6">
              <h3 className="text-xl font-semibold text-[var(--color-primary)] mb-2">
                {tutorial.title}
              </h3>
              <p className="text-[var(--color-black)] mb-4">
                {tutorial.description}
              </p>
              
              <div className="flex items-center justify-between text-sm text-gray-600">
                <div className="flex items-center gap-2">
                  <FaClock />
                  <span>{tutorial.duration}</span>
                </div>
                <div className="flex items-center gap-2">
                  <FaChalkboardTeacher />
                  <span>{tutorial.instructor}</span>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="mt-12 text-center">
        <h2 className="text-2xl font-bold text-[var(--color-primary)] mb-4">
          Daha Fazla İçerik mi Arıyorsunuz?
        </h2>
        <p className="text-[var(--color-black)] mb-6">
          YouTube kanalımızı takip ederek yeni eğitim videolarından haberdar olabilirsiniz.
        </p>
        <a
          href="https://youtube.com/@solartools"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-2 bg-red-600 text-white px-6 py-2 rounded-lg hover:bg-red-700 transition-colors"
        >
          <FaPlay />
          YouTube Kanalımız
        </a>
      </div>
    </div>
  );
} 